var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":{name: 'apps-e-commerce-product-details'}}},[_c('feather-icon',{staticClass:"mr-50",attrs:{"icon":"ShoppingCartIcon","size":"21"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }